import React from "react";
import GeotabBadge from "./GeotabBadge.jsx";
import { deltaTone, driveLegs, driverOf, fmtDelta, fmtDuration, meanDurations } from "./geotabFormat.js";

// « Toute la flotte » : écart moyen par trajet, par chargement et par livraison de chaque camion, avances et retards compris,
// comme l'en-tête du camion. La première ligne reprend la barre du haut (toutes les étapes de la flotte). Clic = ouvrir le camion.
const COLUMNS = [["route", "Route par trajet"], ["loading", "Chargement"], ["delivery", "Livraison"]];

function Gap({ m, tolerance }) {
  if (!m) return <span className="text-slate-300">—</span>;
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="inline-block w-16"><GeotabBadge tone={deltaTone(m.gap, tolerance)} title={`${fmtDuration(m.plan)} prévues → ${fmtDuration(m.real)}`}>{fmtDelta(m.gap)}</GeotabBadge></span>
      {m.count < m.of && <span className="text-[11px] text-slate-500">{m.count} sur {m.of}</span>}
    </span>
  );
}

export default function GeotabFleetSummary({ rows, durations, tolerance, onSelect }) {
  const stays = (row, kind) => meanDurations(row.comparison.sites.filter((s) => s.kind === kind).map((s) => [s.plan_dwell, s.real_dwell]));
  const trucks = rows.filter((row) => row.comparison && row.plan).map((row) => ({
    row, route: meanDurations(driveLegs(row).map((l) => [l.plan, l.real])), loading: stays(row, "loading"), delivery: stays(row, "delivery"),
  }));
  // Moyennes de la barre, arrondies comme elle.
  const fleet = Object.fromEntries(COLUMNS.map(([key]) => {
    const d = durations?.[key];
    if (!d?.count) return [key, null];
    const [plan, real] = [Math.round(d.planned), Math.round(d.real)];
    return [key, { plan, real, gap: real - plan, count: d.count, of: d.of }];
  }));
  const head = "px-1.5 py-1 text-left text-[10px] font-bold uppercase tracking-wide text-slate-500";
  const total = "border-b-2 border-b-slate-400";
  return (
    <section className="overflow-x-auto rounded-[4px] border border-slate-200 bg-white px-2 py-1.5">
      <div className="px-1 pb-1 text-[12px] font-bold text-slate-800">Écarts par camion <span className="font-normal text-slate-500">· moyenne par étape, comme l'en-tête du camion · cliquer une ligne ouvre le camion</span></div>
      <table className="w-full">
        <thead><tr><th className={head}>Camionneur</th>{COLUMNS.map(([key, label]) => <th key={key} className={head}>{label}</th>)}</tr></thead>
        <tbody className="tabular-nums">
          <tr className="font-bold">
            <td className={`px-1.5 py-1 text-[12.5px] ${total}`}>Toute la flotte</td>
            {COLUMNS.map(([key]) => <td key={key} className={`px-1.5 py-1 ${total}`}><Gap m={fleet[key]} tolerance={tolerance} /></td>)}
          </tr>
          {trucks.map((t) => (
            <tr key={t.row.truck_id} onClick={() => onSelect(t.row.truck_id)} className="cursor-pointer border-t border-slate-100 hover:bg-slate-50">
              <td className="px-1.5 py-1 text-[12.5px]"><b className="text-slate-900">{driverOf(t.row)}</b> <span className="text-[11px] text-slate-500">{t.row.truck_name}</span></td>
              {COLUMNS.map(([key]) => <td key={key} className="px-1.5 py-1"><Gap m={t[key]} tolerance={tolerance} /></td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
